<script lang="ts" setup>
const { t } = useI18n()
</script>

<template>
  <section class="international-contact">
    <div class="international-contact__container">
      <div class="international-contact__left">
        <h2 class="international-contact__company">
          {{ t('aboutCompany.internationalContact.company') }}
        </h2>

        <p class="international-contact__address">
          {{ t('aboutCompany.internationalContact.addressLine1') }}<br>
          {{ t('aboutCompany.internationalContact.addressLine2') }}
        </p>

        <p class="international-contact__registry">
          {{ t('aboutCompany.internationalContact.registry') }}
        </p>
      </div>

      <div class="international-contact__right">
        <div class="international-contact__box">
          <h3 class="international-contact__box-title">
            {{ t('aboutCompany.internationalContact.departmentTitle') }}
          </h3>

          <a
            class="international-contact__link"
            :href="`mailto:${t('aboutCompany.internationalContact.departmentEmail').replace('(at)', '@')}`"
          >
            {{ t('aboutCompany.internationalContact.departmentEmail').replace('(at)', '@') }}
          </a>
        </div>

        <div class="international-contact__box">
          <h3 class="international-contact__support-title">
            {{ t('aboutCompany.internationalContact.supportTitle') }}
          </h3>

          <a
            class="international-contact__link"
            :href="`mailto:${t('aboutCompany.internationalContact.supportEmail').replace('(at)', '@')}`"
          >
            {{ t('aboutCompany.internationalContact.supportEmail').replace('(at)', '@') }}
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.international-contact {
  padding: 6rem 2.4rem;

  &__container {
    display: grid;
    gap: 6rem;

    max-width: 156rem;
    margin: 0 auto;

    @include atL {
      grid-template-columns: 2fr 1fr;
    }
  }

  &__company {
    margin-bottom: 4rem;

    color: $darkblue-400;
    font-weight: 600;
    font-size: 4rem;
    line-height: 4.8rem;
  }

  &__address {
    margin-bottom: 3.2rem;

    color: $text-300;
    font-size: 2rem;
    line-height: 3rem;
  }

  &__registry {
    max-width: 80rem;

    color: $text-300;
    font-size: 1.8rem;
    line-height: 3rem;
  }

  &__right {
    display: flex;
    flex-direction: column;
    gap: 3.2rem;
  }

  &__box-title {
    margin-bottom: 1.6rem;

    color: $darkblue-400;
    font-weight: 500;
    font-size: 3.2rem;
  }

  &__support-title {
    margin-bottom: 1.6rem;

    color: $darkblue-400;
    font-weight: 600;
    font-size: 2rem;
    line-height: 3rem;
  }

  &__link {
    color: $color-social;
    font-size: 2rem;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>